import { Dialog, GenericSuspense, useUrlParamsValueToString } from "@bsm/component"
import { Outlet, useNavigate, useParams } from "react-router-dom"
import { useUserStudentFamilyQuery } from "../hooks/useUserStudentFamilyQuery"
import { UserStudentFamilyDetails } from "../components/UserStudentFamilyDetails"

export const UserStudentFamilyDetailsContainer = () => {

    const { familyId } = useParams()
    const urlParams = useUrlParamsValueToString()
    const { data } = useUserStudentFamilyQuery(parseInt(familyId), true)
    const navigate = useNavigate()

    return (
        <Dialog open title={data?.designation} onClose={() => navigate(`..?${urlParams}`)}>
            <UserStudentFamilyDetails {...data} />
            <GenericSuspense>
                <Outlet />
            </GenericSuspense>
        </Dialog>
    )
}
